// extracted by mini-css-extract-plugin
export default {"tooltip":"Gp-z","sharingV2":"Hp-z","sharingIconsV2":"Ip-z","links":"Jp-z","link":"Kp-z","facebookV2":"Lp-z","twitterV2":"Mp-z","pinterestV2":"Np-z"};